import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResponsiveTableModule } from '@ui/responsive-table/responsive-table.module';
import { SharedModule } from 'app/shared/shared.module';

import {
  AprIncentivesTableComponent,
} from './components/apr-incentives/apr-incentives-table/apr-incentives-table.component';
import {
  CustomerIncentivesTableComponent,
} from './components/customer-incentives/customer-incentives-table/customer-incentives-table.component';
import {
  DealerIncentiveEditComponent,
} from './components/dealer-incentives/dealer-incentive-edit/dealer-incentive-edit.component';
import {
  DealerIncentivesTableComponent,
} from './components/dealer-incentives/dealer-incentives-table/dealer-incentives-table.component';
import { DirectDeskDialogComponent } from './components/direct-desk-dialog/direct-desk-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    MatStepperModule,
    MatSelectModule,
    MatListModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    ResponsiveTableModule
  ],
  exports: [DirectDeskDialogComponent],
  entryComponents: [DirectDeskDialogComponent],
  declarations: [
    DirectDeskDialogComponent,
    AprIncentivesTableComponent,
    CustomerIncentivesTableComponent,
    DealerIncentivesTableComponent,
    DealerIncentiveEditComponent
  ]
})
export class DirectDeskModule {}
